module.exports = __webpack_public_path__ + "static/media/text-align-left-gray.023efa90.svg";